"use strict";
exports.__esModule = true;
var react_1 = require("react");
var DimensionValueState_1 = require("../entity/DimensionValueState");
var ChartDimensionState_1 = require("../entity/ChartDimensionState");
function dimensionKeyStateReducer(state, action) {
    if (action.type === 'INIT' && action.initState) {
        return action.initState;
    }
    if (action.type === 'ALL_INIT') {
        var newState = state.map(function (dimensionState) {
            return new ChartDimensionState_1["default"]({
                breakdown: new DimensionValueState_1["default"]({
                    value: dimensionState.breakdown.value,
                    isSelected: false
                }),
                filter: dimensionState.filter.map(function (item) {
                    return new DimensionValueState_1["default"]({ value: item.value, isSelected: false });
                })
            });
        });
        if (action.changeDimension) {
            action.changeDimension(newState);
        }
        return newState;
    }
    if (action.type === 'ALL') {
        var newState = state.map(function (dimensionState, newDimensionIndex) {
            if (newDimensionIndex == action.dimensionIndex) {
                return new ChartDimensionState_1["default"]({
                    breakdown: new DimensionValueState_1["default"]({
                        value: dimensionState.breakdown.value,
                        isSelected: true
                    }),
                    filter: dimensionState.filter.map(function (item, newFilterIndex) {
                        if (action.filterIndex == newFilterIndex) {
                            return new DimensionValueState_1["default"]({ value: item.value, isSelected: true });
                        }
                        else {
                            return new DimensionValueState_1["default"]({ value: item.value, isSelected: false });
                        }
                    })
                });
            }
            else {
                return dimensionState;
            }
        });
        if (action.changeDimension) {
            action.changeDimension(newState);
        }
        return newState;
    }
    if (action.type === 'ALL_SELECT' &&
        typeof action.dimensionIndex == 'number' &&
        typeof action.isSelectedAll == 'boolean') {
        var newState = state.map(function (dimensionState, index) {
            if (index == action.dimensionIndex) {
                return new ChartDimensionState_1["default"]({
                    breakdown: new DimensionValueState_1["default"]({
                        value: dimensionState.breakdown.value,
                        isSelected: !action.isSelectedAll
                    }),
                    filter: dimensionState.filter.map(function (item) {
                        return new DimensionValueState_1["default"]({ value: item.value, isSelected: !action.isSelectedAll });
                    })
                });
            }
            else {
                return dimensionState;
            }
        });
        if (action.changeDimension) {
            action.changeDimension(newState);
        }
        return newState;
    }
    if (action.type === 'FILTER' && action.filterIndex !== undefined && action.dimensionIndex !== undefined) {
        var newState = state.map(function (dimensionState, newDimensionIndex) {
            if (newDimensionIndex == action.dimensionIndex) {
                return new ChartDimensionState_1["default"]({
                    breakdown: dimensionState.breakdown,
                    filter: dimensionState.filter.map(function (item, newFilterIndex) {
                        if (action.filterIndex == newFilterIndex) {
                            return new DimensionValueState_1["default"]({ value: item.value, isSelected: !item.isSelected });
                        }
                        else {
                            return item;
                        }
                    })
                });
            }
            else {
                return dimensionState;
            }
        });
        var fixedState = newState.map(function (dimensionState, newDimensionIndex) {
            if (newDimensionIndex == action.dimensionIndex) {
                return new ChartDimensionState_1["default"]({
                    breakdown: new DimensionValueState_1["default"]({
                        value: dimensionState.breakdown.value,
                        isSelected: dimensionState.filter.some(function (filter) { return filter.isSelected; })
                    }),
                    filter: dimensionState.filter
                });
            }
            else {
                return dimensionState;
            }
        });
        if (action.changeDimension) {
            action.changeDimension(fixedState);
        }
        return fixedState;
    }
    if (action.type === 'CLEAR' && action.dimensionIndex !== undefined) {
        var newState = state.map(function (dimensionState, index) {
            if (index == action.dimensionIndex) {
                return new ChartDimensionState_1["default"]({
                    breakdown: new DimensionValueState_1["default"]({
                        value: dimensionState.breakdown.value,
                        isSelected: false
                    }),
                    filter: dimensionState.filter.map(function (item) {
                        return new DimensionValueState_1["default"]({ value: item.value, isSelected: false });
                    })
                });
            }
            else {
                return dimensionState;
            }
        });
        if (action.changeDimension) {
            action.changeDimension(newState);
        }
        return newState;
    }
    return [];
}
var useDimension = function () {
    var _a = (0, react_1.useReducer)(dimensionKeyStateReducer, []), dimensionKeyState = _a[0], dispatchDimensionKeyState = _a[1];
    var setDimensionKeyState = function (action) {
        dispatchDimensionKeyState(action);
    };
    return [dimensionKeyState, { setDimensionKeyState: setDimensionKeyState }];
};
exports["default"] = useDimension;
